'use strict';
var defineBuiltIn = require('../internals/define-built-in');

module.exports = function (target, src, options) {
  for (var key in src) {
    if (options && options.unsafe && target[key]) target[key] = src[key];
    else defineBuiltIn(target, key, src[key], options);
  } return target;
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/define-built-ins.js
// module id = 656
// module chunks = 13